import type { NextApiResponse } from "next";
import { ProblemSetTypeEnum, UserRoleEnum } from "~/lib/objects";

export function isGameAnalysisSet(type: string | null | undefined): boolean {
  return type === ProblemSetTypeEnum.GAME_ANALYSIS;
}

export function isGameAnalysisRole(role: UserRoleEnum): boolean {
  return role === UserRoleEnum.STUDENT || role === UserRoleEnum.ADMIN;
}

/** Persisted ownership, rather than visibility or administrator privilege, grants access. */
export function canReadAnalysisGame(
  game: Readonly<{
    removed: boolean;
    problemSet: Readonly<{
      type: string;
      removed: boolean;
      uploadedByUserId: number | null;
    }> | null;
  }>,
  actor: Readonly<{ userId: number; role: UserRoleEnum }> | null,
): boolean {
  return Boolean(
    actor &&
      isGameAnalysisRole(actor.role) &&
      !game.removed &&
      game.problemSet &&
      isGameAnalysisSet(game.problemSet.type) &&
      !game.problemSet.removed &&
      game.problemSet.uploadedByUserId !== null &&
      game.problemSet.uploadedByUserId === actor.userId,
  );
}

export class UnsupportedAnalysisOperationError extends Error {
  constructor() {
    super("Analysis games are unavailable for this operation");
  }
}

/** Ordinary routes keep their existing unavailable envelope. */
export function rejectUnsupportedAnalysisSource(
  type: string | null | undefined,
  res: NextApiResponse,
  message = "Problem not found",
): boolean {
  if (!isGameAnalysisSet(type)) return false;
  res.status(404).json({ message });
  return true;
}
